module.exports = __webpack_public_path__ + "static/media/dat-hang-ngay.09f68a72.gif";